import { Provider as StoreProvider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import "react-toastify/dist/ReactToastify.css";
import Pages from "./pages";
import CustomThemeProvider from "~/components/CustomThemeProvider";
import AuthProvider from "~/components/AuthProvider";
import history from "./packages/history";
import { store, persistor } from "./store";
import "./packages/i18n";
import MsalAuthProvider from "./components/MsalAuthProvider";

const App = () => {
  return (
    <div className="app">
      <StoreProvider {...{ store }}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter {...{ history }}>
            <QueryParamProvider ReactRouterRoute={Route}>
              <CustomThemeProvider>
                <MsalAuthProvider>
                  <AuthProvider>
                    <Pages />
                  </AuthProvider>
                </MsalAuthProvider>
              </CustomThemeProvider>
            </QueryParamProvider>
          </ConnectedRouter>
        </PersistGate>
      </StoreProvider>
      <ToastContainer />
    </div>
  );
};

export default App;
